/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Past_TeamsInputs */

const th_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมเดิม`)
};

const en_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previously`)
};

const ja_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過去の所属`)
};

const zh_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`过往`)
};

const es_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteriormente`)
};

const pt_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteriormente`)
};

const id_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sebelumnya`)
};

const fr_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auparavant`)
};

const tl_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati`)
};

const vi_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trước đây`)
};

const ko_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전`)
};

const de_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher`)
};

const ru_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранее`)
};

const tr_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceden`)
};

const it_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In precedenza`)
};

const pl_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wcześniej`)
};

const uk_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раніше`)
};

const hi_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले`)
};

const ar_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سابقًا`)
};

const ms_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dahulu`)
};

const bn_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আগে`)
};

const zh_tw2_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過往`)
};

const zh_hk2_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`過往`)
};

const ur_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پہلے`)
};

const fa_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پیش‌تر`)
};

const sw_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awali`)
};

const nl_player_past_teams = /** @type {(inputs: Player_Past_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerder`)
};

/**
* | output |
* | --- |
* | "Previously" |
*
* @param {Player_Past_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_past_teams = /** @type {((inputs?: Player_Past_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Past_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_past_teams(inputs)
	if (locale === "ja") return ja_player_past_teams(inputs)
	if (locale === "zh") return zh_player_past_teams(inputs)
	if (locale === "es") return es_player_past_teams(inputs)
	if (locale === "pt") return pt_player_past_teams(inputs)
	if (locale === "id") return id_player_past_teams(inputs)
	if (locale === "fr") return fr_player_past_teams(inputs)
	if (locale === "tl") return tl_player_past_teams(inputs)
	if (locale === "vi") return vi_player_past_teams(inputs)
	if (locale === "ko") return ko_player_past_teams(inputs)
	if (locale === "de") return de_player_past_teams(inputs)
	if (locale === "ru") return ru_player_past_teams(inputs)
	if (locale === "tr") return tr_player_past_teams(inputs)
	if (locale === "it") return it_player_past_teams(inputs)
	if (locale === "pl") return pl_player_past_teams(inputs)
	if (locale === "uk") return uk_player_past_teams(inputs)
	if (locale === "hi") return hi_player_past_teams(inputs)
	if (locale === "ar") return ar_player_past_teams(inputs)
	if (locale === "ms") return ms_player_past_teams(inputs)
	if (locale === "bn") return bn_player_past_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_player_past_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_player_past_teams(inputs)
	if (locale === "ur") return ur_player_past_teams(inputs)
	if (locale === "fa") return fa_player_past_teams(inputs)
	if (locale === "sw") return sw_player_past_teams(inputs)
	if (locale === "nl") return nl_player_past_teams(inputs)
	return en_player_past_teams(inputs)
});